import { loadDirectoryCSV } from "../../directory/csv/loadDirectoryCSV";
import { CSV_URL } from "../../directory/csv/url";
// import { scrapeDirectoryHTML } from "../../directory/scrape/scrapeDirectoryHTML";
import { closeGroupDetails } from "./closeGroupDetails";
import { initialHTML } from "./initialHTML";
import { listGroups } from "./listGroups";
import { openGroupDetails } from "./openGroupDetails";
initialHTML();
// scrapeDirectoryHTML().then(listGroups);
loadDirectoryCSV(CSV_URL).then(listGroups);
document.querySelector("body").addEventListener("click", (e) => {
    const target = e.target;
    const targetClassList = target.classList;
    if (targetClassList.contains("group-link")) {
        e.preventDefault();
        openGroupDetails(target.id, document.querySelector(".group-details"));
        // navigator.clipboard.writeText(getGroupEmails(e.target.id));
    }
    if (targetClassList.contains("group-details__close") ||
        targetClassList.contains("group-details__background")) {
        e.preventDefault();
        closeGroupDetails(document.querySelector(".group-details"));
        // navigator.clipboard.writeText(getGroupEmails(e.target.id));
    }
});
